import splide from './components/splide'
import flowerSplide from './components/flowerSplide'
import orderDate from './components/orderDate'
import orderKana from './components/orderKana'
import orderEmail from './components/orderEmail'
import orderBudget from './components/orderBudget'
import orderRadio from './components/orderRadio'
import orderFormSubmit from './components/orderFormSubmit'
import orderNumber from './components/orderNumber'
import orderName from './components/orderName'
import orderTime from './components/orderTime'
import orderPrivacy from './components/orderPrivacy'
import orderNotice from './components/orderNotice'
import orderZip from './components/orderZip'
import orderSelect from './components/orderSelect'
import completeSubmit from './components/completeSubmit'

document.addEventListener(
  'DOMContentLoaded',
  () => {
    splide();
    flowerSplide();
    orderDate()
    orderTime()
    orderName()
    orderKana()
    orderBudget()
    orderEmail()
    orderNumber()
    orderZip()
    orderRadio()
    orderNotice()
    orderSelect()
    orderFormSubmit()
    orderPrivacy()
    completeSubmit()
  },
  false
)
